import React, { useEffect } from 'react';
import './TraitsAndRarities.css';

function TraitsAndRarities() {
  const traits = {
    "Background": ["Orange", "Chartreuse", "Green", "Salmon", "Yellow", "Blue", "Pink"],
    "Water": ["Purple", "Red", "Orange", "Green", "Cyan", "Yellow", "Blue"],
    "Body": ["Dull Orange", "Dull Cyan", "Dull Pink", "Grey", "Cyan", "Dull Blue", "Dull Green", "Dull Purple", "Dull Red", "Orange", "Yellow", "Blue", "Green", "Red", "Purle", "Magenta", "Clear"],
    "Outline": ["Black"],
    "Shadows": ["Normal", "Squigles", "Dots", "Stripes"],
    "Mouth": ["Donkey Teeth", "Chompers", "Normal", "Tongue", "Grin", "Nervous", "Smile", "Dino Mouth", "Weak Tongue", "Dog Nose"],
    "Eyes": ["Mean", "Normal", "Angry", "Stoned", "Squint", "Bulge", "Dull", "Small", "Half", "Cool", "Long", "Pharaoh", "Wierd"],
    "Swag": ["Bandana", "Goggles", "Chain", "Collar", "Earring", "Earrings", "Crown", "Headphones", "None"],
    "Pup": ["Purple", "Yellow", "Grey", "Green", "Cyan", "Orange", "Blue", "None"],
  };

  const traitPercentages = {
    "Background": {
      "Orange": "44.58%",
      "Chartreuse": "28.51%",
      "Green": "9.64%",
      "Salmon": "6.02%",
      "Yellow": "8.43%",
      "Blue": "1.61%",
      "Cyan": "0.40%",
      "Pink": "0.80%"
    },
    "Water": {
      "Purple": "32.93%",
      "Red": "41.77%",
      "Orange": "16.47%",
      "Green": "5.22%",
      "Cyan": "0.80%",
      "Yellow": "1.61%",
      "Blue": "1.20%"
    },
    "Body": {
      "Dull Orange": "10.44%",
      "Dull Cyan": "8.84%",
      "Dull Pink": "4.82%",
      "Dull Blue": "6.83%",
      "Grey": "8.03%",
      "Cyan": "6.43%",
      "Orange": "6.43%",
      "Blue": "4.82%",
      "Dull Green": "5.22%",
      "Dull Purple": "4.82%",
      "Green": "5.22%",
      "Dull Red": "4.82%",
      "Yellow": "6.83%",
      "Clear": "1.61%",
      "Purle": "4.02%",
      "Red": "6.02%",
      "Magenta": "4.82%"
    },
    "Outline": {
      "Black": "100.00%"
    },
    "Shadows": {
      "Normal": "90.36%",
      "Squigles": "2.81%",
      "Stripes": "4.42%",
      "Dots": "2.41%"
    },
    "Mouth": {
      "Donkey Teeth": "13.25%",
      "Chompers": "33.33%",
      "Normal": "28.11%",
      "Tongue": "6.83%",
      "Nervous": "5.22%",
      "Grin": "4.82%",
      "Dino Mouth": "4.02%",
      "Smile": "1.20%",
      "Dog Nose": "1.20%",
      "Weak Tongue": "2.01%"
    },
    "Eyes": {
      "Mean": "9.24%",
      "Normal": "56.63%",
      "Stoned": "0.80%",
      "Squint": "2.41%",
      "Bulge": "1.20%",
      "Angry": "15.66%",
      "Half": "5.22%",
      "Cool": "1.20%",
      "Wierd": "2.41%",
      "Long": "0.80%",
      "Small": "2.81%",
      "Dull": "0.40%",
      "Pharaoh": "1.20%"
    },
    "Swag": {
      "Bandana": "16.06%",
      "Goggles": "1.20%",
      "None": "59.44%",
      "Chain": "6.43%",
      "Collar": "4.42%",
      "Earring": "4.82%",
      "Crown": "2.41%",
      "Earrings": "3.61%",
      "Headphones": "0.40%",
      "Beanie": "0.80%",
      "Horn": "0.40%"
    },
    "Pup": {
      "None": "49.00%",
      "Purple": "5.62%",
      "Yellow": "6.02%",
      "Grey": "16.47%",
      "Cyan": "10.04%",
      "Green": "10.04%",
      "Orange": "2.01%",
      "Blue": "0.40%",
      "Red": "0.40%"
    }
  };

  useEffect(() => {
    const contentWrapper = document.querySelector('.content-wrapper');
    const body = document.body;
    const originalBodyClassName = body.className;

    // For desktop
    if (window.innerWidth > 768) {
      if (contentWrapper) {
        contentWrapper.classList.add('traits-rarities-background');
      }
    }
    // For mobile
    else {
      body.className = 'traits-rarities-background';
    }

    return () => {
      // For desktop
      if (window.innerWidth > 768) {
        if (contentWrapper) {
          contentWrapper.classList.remove('traits-rarities-background');
        }
      }
      // For mobile
      else {
        body.className = originalBodyClassName;
      }
    };
  }, []);

  return (
    <section className="traits-rarities-content">
      <div className="traits-rarities-container">
        <div className="traits-section">
          <h2>Traits</h2>
          <table className="traits-table">
            <thead>
              <tr>
                <th>Trait</th>
                <th>Available Variants</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(traits).map(([trait, variants]) => (
                <tr key={trait}>
                  <td>{trait}</td>
                  <td className="variants-cell">
                    <div className="variants-wrapper">{variants.join(', ')}</div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <h2 className="rarity-title">Rarity Breakdown</h2>
          <div className="rarity-grid">
            {['Outline', 'Shadows', 'Mouth', 'Swag', ...Object.keys(traitPercentages)
              .filter(trait => trait !== 'Outline' && trait !== 'Shadows' && trait !== 'Mouth' && trait !== 'Swag')]
              .map(trait => (
                <div key={trait} className="rarity-card">
                  <h3>{trait}</h3>
                  <div className="rarity-variants">
                    {Object.entries(traitPercentages[trait])
                      .sort(([, a], [, b]) => parseFloat(b) - parseFloat(a))
                      .map(([variant, percentage]) => (
                        <div key={variant} className="rarity-row">
                          <span className="variant-name">{variant}</span>
                          <span className="variant-percentage">{percentage}</span>
                        </div>
                      ))}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default TraitsAndRarities;
